export const constants = {
	CHANGE_FILTER: 'CHANGE_FILTER',
	CREATE_REPORT: 'CREATE_REPORT',
	OPEN_RESOURCE_DIALOG: 'OPEN_RESOURCE_DIALOG',
	CLOSE_RESOURCE_DIALOG: 'CLOSE_RESOURCE_DIALOG',
	ADD_RESOURCE_LOADING: 'ADD_RESOURCE_LOADING',
	ADD_RESOURCE_STOP_LOADING: 'ADD_RESOURCE_STOPE_LOADING',
	OPEN_DELETE_RESOURCE_DIALOG: 'OPEN_DELETE_RESOURCE_DIALOG',
	CLOSE_DELETE_RESOURCE_DIALOG: 'CLOSE_DELETE_RESOURCE_DIALOG',
	OPEN_EDIT_RESOURCE_DIALOG: 'OPEN_EDIT_RESOURCE_DIALOG',
	ISSUEDIALOG_OPEN: 'ISSUEDIALOG_OPEN',
	ISSUEDIALOG_CLOSE: 'ISSUEDIALOG_CLOSE',
	OPEN_DELETE_ISSUE_DIALOG: 'OPEN_DELETE_ISSUE_DIALOG',
	CLOSE_DELETE_ISSUE_DIALOG: 'CLOSE_DELETE_ISSUE_DIALOG',
	OPEN_MOVE_DRAWER_DIALOG: 'OPEN_MOVE_DRAWER_DIALOG',
	CLOSE_MOVE_DRAWER_DIALOG: 'CLOSE_MOVE_DRAWER_DIALOG',
    OPEN_TIMELINE_DIALOG: 'OPEN_TIMELINE_DIALOG',
    CLOSE_TIMELINE_DIALOG: 'CLOSE_TIMELINE_DIALOG',
    ADD_ISSUE_LOADING: 'ADD_ISSUE_LOADING',
    ADD_ISSUE_STOP_LOADING: 'ADD_ISSUE_STOP_LOADING',
	OPEN_EDIT_ISSUE_DIALOG: 'OPEN_EDIT_ISSUE_DIALOG',
	OPEN_SCHEDULE_DRAWER:  'OPEN_SCHEDULE_DRAWER',
	CLOSE_SCHEDULE_DRAWER: 'CLOSE_SCHEDULE_DRAWER',
	ADD_SCHEDULE_LOADING: 'ADD_SCHEDULE_LOADING',
	ADD_SCHEDULE_STOP_LOADING: 'ADD_SCHEDULE_STOP_LOADING',
	SELECT_SCHEDULE: 'SELECT_SCHEDULE',
	SELECT_PROJECT: 'SELECT_PROJECT',
	OPEN_PROJECT_USER_DIALOG: 'OPEN_PROJECT_USER_DIALOG',
	CLOSE_PROJECT_USER_DIALOG: 'CLOSE_PROJECT_USER_DIALOG',
	OPEN_TAG_DIALOG: 'OPEN_TAG_DIALOG',
	CLOSE_TAG_DIALOG: 'CLOSE_TAG_DIALOG',
	OPEN_TRADE_DIALOG: 'OPEN_TRADE_DIALOG',
	CLOSE_TRADE_DIALOG: 'CLOSE_TRADE_DIALOG',
	ADD_TRADE_LOADING: 'ADD_TRADE_LOADING',
	ADD_TRADE_STOP_LOADING: 'ADD_TRADE_STOP_LOADING',
	ADD_CONSTRAINT_LOADING: 'ADD_CONSTRAINT_LOADING',
	ADD_CONSTRAINT_STOP_LOADING: 'ADD_CONSTRAINT_STOP_LOADING',
	ADD_PHASE_TAG_LOADING: 'ADD_PHASE_TAG_LOADING',
	ADD_PHASE_TAG_STOP_LOADING: 'ADD_PHASE_TAG_STOP_LOADING',
	OPEN_MILESTONE_DIALOG: 'OPEN_MILESTONE_DIALOG',
	CLOSE_MILESTONE_DIALOG: 'CLOSE_MILESTONE_DIALOG',
	OPEN_DELETE_TAG_DIALOG: 'OPEN_DELETE_TAG_DIALOG',
	CLOSE_DELETE_TAG_DIALOG: 'CLOSE_DELETE_TAG_DIALOG',
	OPEN_DUPLICATE_TAG_DIALOG: 'OPEN_DUPLICATE_TAG_DIALOG',
	CLOSE_DUPLICATE_TAG_DIALOG: 'CLOSE_DUPLICATE_TAG_DIALOG',
	OPEN_RIP_TAG_DIALOG: 'OPEN_RIP_TAG_DIALOG',
	CLOSE_RIP_TAG_DIALOG: 'CLOSE_RIP_TAG_DIALOG',
	CHANGE_PHASE_TAG_COLUMN_LOADING: 'CHANGE_TAG_COLUMN_LOADING',
	CHANGE_PHASE_TAG_COLUMN: 'CHANGE_TAG_COLUMN',
	OPEN_LOOKAHEAD_TAG_DIALOG: 'OPEN_LOOKAHEAD_TAG_DIALOG',
	CLOSE_LOOKAHEAD_TAG_DIALOG: 'CLOSE_LOOKAHEAD_TAG_DIALOG',
	ADD_LOOKAHEAD_TAG_LOADING: 'ADD_LOOKAHEAD_TAG_LOADING',
	ADD_LOOKAHEAD_TAG_STOP_LOADING: 'ADD_LOOKAHEAD_TAG_STOP_LOADING',
	ADD_PHASE_TAG_LOADING: 'ADD_PHASE_TAG_LOADING',
	CHANGE_LOOKAHEAD_TAG_COLUMN: 'CHANGE_LOOKAHEAD_TAG_COLUMN',
	CHANGE_LOOKAHEAD_TAG_COLUMN_LOADING: 'CHANGE_LOOKAHEAD_TAG_COLUMN_LOADING',
	OPEN_BATCH_TAG_DIALOG: 'OPEN_BATCH_TAG_DIALOG',
	CLOSE_BATCH_TAG_DIALOG: 'CLOSE_BATCH_TAG_DIALOG'
};



// WEBPACK FOOTER //
// ./src/constants/global.constants.js